module.exports = __webpack_public_path__ + "static/video-3dbcdc1fec5c20d6730577598bf65226.mp4";